module.exports = __webpack_public_path__ + "img/nishio-takumi@1280w.c38daeac.png";